(function() {
  "use strict";
  angular.module("marketPlace.organisations", ["marketPlace.home"]);
})();
